import API from '@/lib/api'
import { useQuery } from '@tanstack/react-query'

export const useMenuCategories = () =>
  useQuery({
    queryKey: ['menu-categories'],
    queryFn: () => API.getMenuCategories().then(res => res.data)
  })

export const useMenuItems = ({ categoryId } = { categoryId: null }) =>
  useQuery({
    queryKey: ['menu-items'],
    queryFn: () => API.getMenuItems({ categoryId }).then(res => res.data)
  })
